import { useQuery } from 'react-query';
import { getCourse, getPublishedItem, getPublishedItems } from '../apis/course';
import { UICourse } from '../../../../packages/types/src/course';
import { UIPublishedItem } from '../../../../packages/types/src/publishedItem';

export const useCourse = (courseId?: string) => {
	return useQuery({
		queryKey: ['getCourse', courseId],
		queryFn: async () => (await getCourse({ courseId })).data as UICourse,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!courseId,
	});
};

export const usePublishedItems = (courseId?: string) => {
	return useQuery({
		queryKey: ['getPublishedItems', courseId],
		queryFn: async () => (await getPublishedItems({ courseId })).data.publishedItems as UIPublishedItem[],
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!courseId,
	});
};

export const usePublishedItem = (publishedItemId?: string) => {
	return useQuery({
		queryKey: ['getPublishedItem', publishedItemId],
		queryFn: async () => (await getPublishedItem({ publishedItemId })).data.publishedItem as UIPublishedItem,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!publishedItemId,
	});
};
